import { render, staticRenderFns } from "./Edits.vue?vue&type=template&id=0f69a65b&scoped=true&"
import script from "./Edits.vue?vue&type=script&lang=js&"
export * from "./Edits.vue?vue&type=script&lang=js&"
import style0 from "./Edits.vue?vue&type=style&index=0&id=0f69a65b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f69a65b",
  null
  
)

export default component.exports